import { SkeletonBox } from '@/shared/ui';

const PriceInfoSkeleton = () => {
	return (
		<div className="flex flex-1 flex-col items-center gap-2">
			<SkeletonBox className="h-6 w-12 rounded-full" />
			<SkeletonBox className="h-6 w-20" />
			<SkeletonBox className="h-4 w-28" />
		</div>
	);
};

export default PriceInfoSkeleton;
